export enum MODIF_USER {
    PRESTATAIRE = 'prestataire',
    CREATEUR = 'createur',
    CREATEUR_MULTI = 'createur-multi-compte'
}

export const modifUserLabel = (typeUser: string | undefined) => {
    if (typeUser === MODIF_USER.PRESTATAIRE) {
        return 'préstataire'
    } else if (typeUser === MODIF_USER.CREATEUR) {
        return 'créateur'
    } else if (typeUser === MODIF_USER.CREATEUR_MULTI) {
        return 'créateur multi-compte'
    }
}